import { Placeholder } from 'rsuite';
import styled from 'styled-components';

export const StyledSection = styled.div`
  height: ${(props) => `${props.height}px` || '100%'};
  width: ${(props) => `${props.width}px` || '100%'};
  margin: ${(props) => props.margin || 'unset'};
`;

export const SolidSkeletonSection = (props) => (
  <StyledSection
    aria-label={props.ariaLabel}
    data-testid={props.dataTestid ?? 'solid-skeleton-section'}
    height={props.height}
    width={props.width}
    margin={props.margin}
  >
    <Placeholder.Graph height="100%" active />
  </StyledSection>
);

export const SkeletonTitle = (props) => (
  <SolidSkeletonSection
    aria-label={props.ariaLabel}
    height={props.height || 20}
    margin={props.margin || '0px 0px 20px 0px'}
  />
);

export const SkeletonBlock = (props) => (
  <SolidSkeletonSection
    aria-label={props.ariaLabel}
    height={props.height || 125}
    width={props.width}
    margin={props.margin || '0px 0px 20px 0px'}
  />
);
